import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, InjectionToken } from "@angular/core";
import { EpiserverService } from "@ha/feature/episerver";
import { LanguageStateSelectors } from "@ha/ui/common";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { NewsConfiguration } from "../models/news-configuration.model";
import { NewsPage } from "../models/news-page";
import { News } from "../models/news.model";
import { SetNewsStatusCommand } from "../models/set-news-status-command.model";

export const NEWS_CONFIG = new InjectionToken<NewsConfiguration>("NewsConfiguration");

@Injectable({ providedIn: "root" })
export class NewsService {
    private readonly rootUrl = "/sv/kunskapsbank/";

    private readonly angularModuleRoute = "knowledgebank";

    constructor(
        private httpClient: HttpClient,
        private episerverService: EpiserverService,
        private store: Store,
        @Inject(NEWS_CONFIG) private newsConfig: NewsConfiguration,
    ) {}

    public get currentLanguage() {
        return this.store.selectSnapshot(LanguageStateSelectors.currentLanguage) ?? "sv";
    }

    public getAll(): Observable<News[]> {
        const options = {
            params: {
                languageCode: this.currentLanguage,
                application: this.newsConfig.ApplicationFlags,
            },
        };

        return this.httpClient.get<News[]>("/api/News/GetAll", options);
    }

    public getUnreadNews(): Observable<News[]> {
        const options = {
            params: {
                languageCode: this.currentLanguage,
                application: this.newsConfig.ApplicationFlags,
            },
        };

        return this.httpClient.get<News[]>("/api/News/GetUnreadNewss", options);
    }

    public getUnseenNewsCount(): Observable<number> {
        const options = {
            params: {
                languageCode: this.currentLanguage,
                application: this.newsConfig.ApplicationFlags,
            },
        };

        return this.httpClient.get<number>("/api/News/UnseenNewsCount", options);
    }

    public getNewsPage(newsId: number): Observable<NewsPage> {
        return this.episerverService.getContentById(newsId, this.rootUrl, this.angularModuleRoute);
    }

    public setStatusForNews(command: SetNewsStatusCommand): Observable<boolean> {
        return this.httpClient.post<boolean>("/api/News/CreateOrUpdate", command);
    }
}
